<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
if($('.globo-app-extension').length > 0)
{
   var isALARendered;
      function ALAcheck() {
        isALARendered = setInterval(function () {
          customALA()
        }, 100);
      }
      ALAcheck();
      function customALA() {
        if($(".globo-app-extension .wizard__content p").length > 0) {
          clearInterval(isALARendered);        
           $(".globo-app-extension .wizard__content p").remove(":contains('Powered by')");
        }  
      }
}
